import React from 'react';
import { Error } from '@unimed-fesp/components';

function NotFoundPage() {
  const errorNumber = '401';
  const errorTitle = 'oops! não autorizado';
  const errorMessage =
    'Embora o padrão HTTP especifique "não autorizado", semanticamente, essa resposta significa "não autenticado". Ou seja, o cliente deve se autenticar para obter a resposta solicitada...';

  return (
    <Error
      httpCode={errorNumber}
      title={errorTitle}
      message={errorMessage}
      hideButtonReaload
    />
  );
}

export default NotFoundPage;
